const elementSelektor = 'image-zoom';
__webpack_public_path__ = `${document.querySelector('[image-zoom-assets]').dataset["assetBaseUri"]}/image-zoom/`;

async function initImageZoom(event) {
    if (document.querySelector(elementSelektor)) {
        try {
            const { ImageZoom } = await import(/* webpackChunkName: "image-zoom" */ "./image-zoom.js");
        } catch (error) {
            console.error(error);
        }
    }
}

window.addEventListener('load', initImageZoom);
